import { useMutation } from '@tanstack/react-query';
import apiClient from 'core/services/apiClient/apiClient';

export const useDeleteRest = <TDeleteResult>(pathURL: string) => {
  return useMutation<TDeleteResult, Error, string>({
    mutationFn: async (pathParams) => {
      const { data } = await apiClient.delete<TDeleteResult>(
        `${pathURL}/${pathParams}`
      );
      return data;
    }
  });
};
